import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import TicketCount from '@/data/models/domain/tickets/TicketCount'
import type { Dict } from '@/types'
import { httpBuildQuerySerializer } from '@/utils/url'
import type { TicketGetCountRequestBody } from '@/services/domain/tickets/types'

@RepoSettings<Endpoint>({
  model: TicketCount,
})
@injectable()
@injectFromBase()
export default class TicketsCountRepository extends OrmApiRepository<TicketCount> {
  private id = '1'

  public async fetchCount(params?: TicketGetCountRequestBody) {
    const endpoint = this.endpointsService.getPath('ticketsCount')
    const { data } = await this.getApiSource().get<{ count: number }>(endpoint, {
      params,
      paramsSerializer: (serializableParams: Dict) => httpBuildQuerySerializer(serializableParams),
    })
    return data.count
  }

  public fetchUnreadCountValue() {
    return this.fetchCount({
      filters: [{ isRead: { eq: 0 } }],
    })
  }

  public persistUnreadTicketsCount(count: number) {
    return this.insertOrUpdate([
      {
        id: this.id,
        count,
      },
    ])
  }

  public findUnreadTicketsCount() {
    return this.findEntityByIdOrNull(this.id)?.count ?? null
  }

  public updateUnreadTicketsCount(count: number) {
    this.update([
      {
        id: this.id,
        count,
      },
    ])
  }
}
